import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createToken, fetchTokens, revokeToken } from 'actions'
import CustomersSettings from '../components/Customers/CustomersSettings'

class CustomersSettingsApp extends Component {
  render () {
    return React.createElement(CustomersSettings, this.props)
  }

  componentDidMount () {
    this.props.onMount()
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params

  const { isRequesting, didRequestFail, data } = state.tokens[workspaceSlug] || {}

  return {
    isRequesting,
    didRequestFail,
    tokens: data || []
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const { workspaceSlug } = ownProps.params
  return {
    onGenerateToken: (data) => dispatch(createToken(workspaceSlug, data)),
    onRevokeToken: (accessKey) => dispatch(revokeToken(workspaceSlug, accessKey)),
    onMount: () => {
      dispatch(fetchTokens(workspaceSlug))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersSettingsApp)



// WEBPACK FOOTER //
// ./containers/CustomersSettingsApp.js